import type { TOC } from '@ember/component/template-only'
import { eq } from 'ember-truth-helpers'
import type { ThemeKeys } from 'teacher-ui-client/utils/themes'

interface Signature {
  Element: HTMLSelectElement
  Args: {
    themeKey?: ThemeKeys
  }
  Blocks: {
    default: []
  }
}
// A themed select component.
// Uses native select hence does not support styling of options.
export const BaseSelect: TOC<Signature> = <template>
  <select
    class="select-caret-icon border-dusty-black-100 text-dusty-black-300 hover:bg-dusty-black-50 focus:bg-dusty-black-50 disabled:*:bg-dusty-black-100 cursor-pointer appearance-none rounded-md border bg-white bg-size-[0.7rem] bg-position-[right_-1.5rem_center] bg-no-repeat bg-origin-content py-2 pr-8 pl-2 outline-hidden outline-offset-0 transition-all duration-200 disabled:cursor-not-allowed
      {{unless @themeKey 'focus:outline-dusty-black-300/75'}}
      {{if (eq @themeKey 'blue') 'focus:border-oceany-blue-400 focus:outline-oceany-blue-300/75'}}
      {{if (eq @themeKey 'green') 'focus:border-ms-green-400 focus:outline-ms-green-300/75'}}
      {{if (eq @themeKey 'dark-blue') 'focus:border-wl-blue-250 focus:outline-wl-blue-300/75'}}
      "
    ...attributes
  >{{yield}}</select>
</template>

export default BaseSelect
